import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useSession } from "@/lib/session";

/**
 * The console's own gate. A member who types the URL is sent home silently,
 * which is what the account menu already implies by never showing them the
 * entry. The server enforces the same rule independently on every route —
 * this exists so the page never flashes an admin frame before a 403.
 */
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { status } = useSession();
  if (!status.user?.is_admin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
